import {WixSdk} from 'js-sdk-wrapper';
import {dashToSnakeCase} from './strings';
export {createParam} from 'music-shared/dist/src/utils/url';

export function getHostname(url) {
  return url.split(/\/+/)[1];
}

export function getParam(param) {
  return decodeURIComponent((location.search.match(new RegExp('[&?]' + param + '=([^&]*)')) || ['', ''])[1]);
}

export function getUrlPrefixes() {
  return {
    audio: WixSdk.Utils.Media.getAudioUrl('', WixSdk.Utils.Media.AudioType.PREVIEW).replace(/https?:/, '')
      .replace('static.wixstatic.com', 'music.wixstatic.com'),
    image: '//' + getHostname(WixSdk.Media.getResizedImageUrl('')) + '/'
  };
}

export function getHostAndPath(withProtocol) {
  const protocol = withProtocol ? location.protocol : '';
  const host = location.host;
  const pathName = location.pathname.replace(/[^/]+$/, '');
  return protocol + '//' + host + pathName;
}

export function getWixMusicQueryParams(queryString) {
  return queryString ? queryString.split('?').pop()
    .split('&')
    .filter(queryParam => {
      return queryParam.indexOf('wix-music-') === 0;
    })
    .reduce((queryParams, param) => {
      const keyValue = param.split('=');
      const key = dashToSnakeCase(keyValue[0].replace(/^wix-music-/i, ''));
      queryParams[key] = keyValue[1];
      return queryParams;
    }, {}) : {};
}

export function getSharedTrackId(siteInfo) {
  if (!siteInfo && !siteInfo.url) {
    return;
  }
  const wixMusicQueryParams = getWixMusicQueryParams(siteInfo.url);
  if (wixMusicQueryParams.compId === WixSdk.Utils.getCompId() && wixMusicQueryParams.trackId) {
    return wixMusicQueryParams.trackId;
  }
}




// WEBPACK FOOTER //
// ./utils/url.ts